"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getNetworkId = (networkName = 'mainnet') => {
    switch (networkName) {
        case 'mainnet': return 1;
        case 'ropsten': return 3;
        case 'rinkeby': return 4;
        case 'kovan': return 42;
        case 'goerli': return 5;
        case 'ganache': return 1337;
        default: return 1;
    }
};
exports.default = getNetworkId;
